export const paramsKeys = {
  PERMANENT_TOKEN: 'perm_token',
  /** this is the temp sign up token, meant to be sent to `/web/v1/account/sign-up-temporarily-token-exchange` */
  TOKEN: 'token',
  PROMOCODE: 'code',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  APP_URL: 'app_url',
  APP_IDENTITY: 'app-identity',
  ACCOUNT_ID: 'account_id',
  LANGUAGE: 'lang',
  OTC_CODE: 'otc-code',

  // outgoing params
  FROM: 'from',
  PLAN: 'plan',

  // trackings
  FUNNEL: 'funnel',
  CLICK_ID: 'clickid',
  IR_CLICK_ID: 'irclickid',
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  AD_SET: 'ad_set',
  SHORTCUT: 'shortcut',
  AD_GROUP_ID: 'adgroupid',
  // Partnerstack tracking params
  PARTNERSTACK_CLICK_ID: 'ps_xid',
  PARTNERSTACK_CLICK_ID_ALT: 'gsxid',
  PARTNERSTACK_PARTNER_KEY: 'gspk',
} as const;

export const getParsedParams = (): Record<keyof typeof paramsKeys, string | null> => {
  const params = new URLSearchParams(window.location.search);

  return Object.entries(paramsKeys).reduce((acc: Record<string, string | null>, entry) => {
    const [key, value] = entry;

    acc[key] = params.get(value);

    return acc;
  }, {});
};
